import {blobToBase64} from '@legit.health/ui';
import FormValues from '../interfaces/FormValues';

export default async function mapFormValuesToApiFormat(images: FormValues) {
  const formValues: {[key: string]: any} = {};
  for (const imageKey in images) {
    const image = images[imageKey as keyof FormValues];
    if (!image.file) {
      continue;
    }
    const {crop, file} = image;
    if (!crop || !file) {
      throw new Error('Invalid values');
    }
    const base64Image = await blobToBase64(file);
    formValues[imageKey] = {
      x: crop.x,
      y: crop.y,
      width: crop.width,
      height: crop.height,
      image: base64Image
    };
  }

  return formValues;
}
